import { createSelector } from 'reselect';

export const selectOpenClaimState = (state: any) => state.get('openClaim');

const makeSelectSearchClaimInfo = () =>
  createSelector(selectOpenClaimState, (openClaim: any) => {
    if (openClaim && openClaim.get('claimInfo')) {
      return openClaim.get('claimInfo').toJS();
    }
    return [];
  });
export { makeSelectSearchClaimInfo };
